import { Component, Inject, OnInit, ApplicationRef, NgZone, OnDestroy } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { NavController } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { concat, interval, Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import * as moment from 'moment';
import { register } from 'swiper/element/bundle';
register();
import { Storage } from '@ionic/storage-angular';
import { ApiService } from '../app/api.service';
import { UsuarioServiceProvider, FuncionesServiceProvider,} from './service/index.providers';
import { MenuServiceProvider } from 'src/app/service/index.providers';
import { NotificacionService } from 'src/app/service/notificaciones-service/notificacion.service';
import { MultipleOptionModalComponent } from './components/multiple-option-modal/multiple-option-modal.component';
import { environment } from '../environments/environment';
import { Capacitor } from '@capacitor/core';
import { OfflineService } from './service/offline-service/offline.service';
import { ConexionServiceProvider, ConnectionStatus } from './service/conexion-service/conexion-service';
import { StorageService } from './service/storage-service/storage-service.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { DownloadFileService } from './service/download-files-service/download-file.service';
import { EchoService } from './service/echo-service/echo.service';
import { LanguageService } from './service/language-service/language.service';
import { SyncService } from './service/offline-service/sync_checklist.service';
import { LoginMultiModuloService } from './service/login-multi-modulo/login-multi-modulo.service';
import { AppPlatformService } from './service/platform/app-platform.service';
import { KeyboardService } from './service/keyboard/keyboard.service';
import { OrientationService } from './service/orientation/orientation.service';
import { CapacitorSafeService } from './service/iframe-in-app/capacitor-safe.service';
import { ThemeColorsService } from './service/theme-colors/theme-colors.service';
import { NotificationsActivitiesService } from './service/calendar-service/notifications-activities.service';
import { CalendarService } from './service/calendar-service/calendar.service';
import { SqliteWrapperService } from './service/sqlite-wrapper/sqlite-wrapper.service';
import { PushNotificationsService } from './service/fcm-service/push-notifications-service';
declare var cordova: any;
declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit , OnDestroy{
  public rootPage: any;
  fullscreen: boolean = false;
  userID: any = null;
  domain: any = null;
  platformIsIOS: boolean | null = null;
  showImpersonationBar: boolean = false;
  impersonationBarTitle: string = "";

  config_empresa: any = null;
  data_usuario: any;
  initials:any;
  userProfileData: any;
  checkUpdateInterval;
  webCurrentVersion:any;
  webAvailableVersion:any;
  userIsLogged = false;

  //**config Cursalab del espacio multimarca**
  defaultConfigData;
  private networkObservable: Subscription;
  networkIsActive: boolean = true;
  language:string = "es";
  mobileMenuIsOpen = false;
  keyboardHidden = true;
  private keyboardSubscription: Subscription;
  private LoadingSubscription: Subscription;
  private orientationSubscription!: Subscription;
  isLandscape: boolean = false;
  loadingScreenIsActive: boolean = false;
  pushPermissionModalIsOpen: boolean = false;
  private pushPermissionCheckedThisLaunch: boolean = false;
  private pushPermissionSubscription: Subscription;

  constructor(
    public platform: Platform,
    private titleService: Title,
    private up: UsuarioServiceProvider,
    private fp: FuncionesServiceProvider,
    public router: Router,
    private zone: NgZone,
    // private fcm: FCM,
    private Storage: Storage,
    public navCtrl: NavController,
    // private iab: InAppBrowser,
    // private LocalNotifications: LocalNotifications,
    private mp: MenuServiceProvider,
    private api: ApiService,
    // private statusBar: StatusBar,
    private swUpdate: SwUpdate,
    private appRef: ApplicationRef,
    private alertCtrl: AlertController,
    @Inject(DOCUMENT) private document: any,
    private modalCtrl: ModalController,
    private networkService: ConexionServiceProvider,
    private offlineHttpService: OfflineService,
    private storageService: StorageService,
    private downloadFileService: DownloadFileService,
    private echoService: EchoService,
    public languageService: LanguageService,
    public syncService: SyncService,
    private loginMultiModuloService: LoginMultiModuloService,
    private appPlatformService:AppPlatformService,
    private keyboardService: KeyboardService,
    private orientationService: OrientationService,
    public capacitorSafe: CapacitorSafeService,
    private themeColorsService: ThemeColorsService,
    private notificationsActivitiesService: NotificationsActivitiesService,
    private calendarService: CalendarService,
    private sqliteWrapper: SqliteWrapperService,
    private pushNotificationsService: PushNotificationsService,
  )
  {
    this.defaultConfigData = this.themeColorsService.defaultConfigData;

    if(environment.APP_MULTIMARCA && this.appPlatformService.isAppPlatform()) {
      SplashScreen.hide();
      this.router.navigate(['/splash-screen']);
    }

    this.up.configBrand.subscribe((res:any) => {
      this.config_empresa = res;
    });
    console.log('Ver. web: ', environment.WEB_VERSION);
    this.domain = this.document.location.hostname;
    this.addGoogleAnalyticsScript();

    if (
      swUpdate?.isEnabled &&
      (this.platform.is('desktop') || !this.platform.is('cordova'))
    ) {
      try {
        this.swUpdate?.versionUpdates.subscribe((event) => {
          if(event.type === "VERSION_READY") {
            console.log('current version::: ', event.currentVersion?.hash);
            console.log('available version::: ', event.latestVersion?.hash);
            console.log('available version appData::: ', event.latestVersion?.appData);
            if (
              this.webCurrentVersion &&
              this.webCurrentVersion === event.currentVersion?.hash &&
              this.webAvailableVersion &&
              this.webAvailableVersion === event.latestVersion?.hash
            ) {
              console.log('already informed');
            } else {
              this.webCurrentVersion = event.currentVersion?.hash;
              this.webAvailableVersion = event.latestVersion?.hash;
              console.log('reload message sw');
              this.unregisterServiceWorker();
              setTimeout(() => {
                window.location.reload()
              }, 2000);
              // this.reloadMessage();
            }

          }
        });
      } catch (error) {
        console.log(error)
      };

      const appIsStable$ = appRef.isStable.pipe(
        first((isStable) => isStable === true)
      );
      const everyTwoHour$ = interval(7200000);

      const everyTwoHourOnceAppIsStable$ = concat(appIsStable$, everyTwoHour$);

      this.checkUpdateInterval = everyTwoHourOnceAppIsStable$.subscribe(
        (intervalNumber) => {
          if (intervalNumber !== true) {
            try {
              swUpdate?.checkForUpdate().then((updateFound) => {
                console.log('checking for updates');
              });
            } catch (err) {
              console.error('Failed to check for updates', err);
            }
          }
        }
      );
    }

    this.mp.currentHideFooter.subscribe((state:any) => (this.fullscreen = state));

    this.up.isLogged.subscribe((res:any) => {
      this.userIsLogged = res;
      if (this.userIsLogged) {
        // console.log("********************* userIsLogged *********************")
        // Reconcilia la plataforma seleccionada con la ruta real al reabrir la app.
        // isPerformanceAccessSelected solo se limpia en logout, así que si el navegador
        // se cerró dentro de Desempeño y se reabre en una ruta que NO es de Desempeño
        // (p.ej. la raíz -> anuncios), el flag queda "true" y cargarFunciones() arma el
        // menú de Desempeño sobre contenido de capacitación/inducción. Se limpia aquí
        // para que el menú corresponda a la plataforma realmente cargada.
        const isPerformanceRoute = window.location.pathname.startsWith('/performance');
        if (!isPerformanceRoute && localStorage.getItem('isPerformanceAccessSelected') === 'true') {
          localStorage.setItem('isPerformanceAccessSelected', 'false');
        }
        this.data_usuario = JSON.parse(localStorage.getItem('user_data'));
        // console.log("data_usuario",this.data_usuario)
        if (this.data_usuario) {
          this.initials =
            this.data_usuario.nombre.charAt(0).toUpperCase() +
            this.data_usuario.apellido.charAt(0).toUpperCase();
          this.userProfileData = this.data_usuario;
          // this.userProfileData = this.data_usuario.full_name;
          this.calendarService.setCalendarIsAvailable(this.data_usuario?.has_calendar);
          console.log("User has cal:", this.data_usuario?.has_calendar);
        };

        const finalAppTheme = JSON.parse(localStorage.getItem('config_ambiente') || 'null');
        const advancedCustomization = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
        //* config de ambiente especifica x workspace */
        // console.log("userIsLogged::", this.userIsLogged)
        // console.log({"finalAppTheme": finalAppTheme, "advancedCustomization": advancedCustomization});
        if (finalAppTheme) {
          this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomization, finalAppTheme, false);
        };

        this.up.load_storage();
        this.mp.setSelectedPageRoute(localStorage.getItem('select_page') || '');

        setTimeout(() => {
          this.fp.cargarFunciones();
        }, 2200);
        this.userID = this.up.getIdUsuario;
        //validate impersonation session
        const configData = JSON.parse(localStorage.getItem('config_data') || "{}");
        if (configData.impersonation) {
          setTimeout(() => {
            this.showImpersonationBar = configData.impersonation.show_bar;
            this.impersonationBarTitle = configData.impersonation.show_title;
          }, 1000);
        }

        this.platform.ready().then(() => {
          if (this.appPlatformService.isAppPlatform()) {
            console.log('USUARIO LOGUEADO INIT HTTP OFFLINE SERVICE');
            // this.syncService.resetChecklistSyncStatus();

            setTimeout(() => {
                this.syncService.checkAndSyncIfNeeded();
                this.offlineHttpService.sendPendingOfflineRequests();
              }, 5000);

            // Auto-login: si el permiso de notificaciones está denegado, mostrar el modal
            // para activarlo manualmente (solo una vez por apertura de la app).
            if (!this.pushPermissionCheckedThisLaunch) {
              this.pushPermissionCheckedThisLaunch = true;
              this.pushNotificationsService.promptEnableNotificationsIfDenied();
            }
          }
        });

        const token = localStorage.getItem("token");

        this.echoService.setChannels(this.data_usuario, token, configData)

        // Deep-link o recarga directa dentro de Desempeño: el NavigationEnd de esa
        // navegación pudo dispararse antes de que Echo existiera, así que el canal se
        // resuelve aquí con la ruta ya cargada.
        if (isPerformanceRoute) {
          this.echoService.joinPerformanceChannel(this.data_usuario?.workspace?.slug);
        }
      } else {
        // console.log("********************* userNOTLogged *********************")
        this.languageService.setDefaultLanguage();
        this.initials = '';
        this.userProfileData = null;

        this.showImpersonationBar = false;
        this.impersonationBarTitle = '';

        if (environment.APP_MULTIMARCA) {
          this.getMultibrandStoredLoginConfig()
        } else {
          // console.log("********************* userNOTLogged *********************")
          this.getBrandedPlanThemeConfig(false);
        };

        this.syncService.removeDatabaseRef();
      }
    });

    //Add dynamic title for selected pages
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let title: string | any = this.getTitle(
          this.router.routerState,
          this.router.routerState.root
        );
        if (this.config_empresa) {
          title.length > 0
            ? titleService.setTitle(
                this.config_empresa.titulo
                  ? this.config_empresa.titulo
                  : 'Cursalab' + ' | ' + title[0]
              )
            : titleService.setTitle(
                this.config_empresa.titulo
                  ? this.config_empresa.titulo
                  : 'Cursalab'
              );
        }
        if (title.length > 0 && title[0] !== 'login') {
          const element = document.getElementsByClassName(
            'grecaptcha-badge'
          )[0] as HTMLElement;
          if (element) {
            element.style.visibility = 'hidden';
          }
        }
        const userJson = localStorage.getItem('user_data');
        const user = userJson !== null ? JSON.parse(userJson) : null;
        // if (user) {
        //   const nps = localStorage.getItem('nps')
        //     ? JSON.parse(localStorage.getItem('nps')!)
        //     : null;
        //   const date = localStorage.getItem('date_nps')
        //     ? JSON.parse(localStorage.getItem('date_nps')!)
        //     : { query: null, sent: null };
        //   const date_now = moment(new Date()).format('L');
        //   if (!nps || (nps && date.query !== date_now)) {
        //     const dni = user.dni;
        //     this.api
        //       .listNPS('app', '2', dni)
        //       .then((res: any) => {
        //         const date_nps = { query: date_now, sent: null };
        //         if (date.sent === date_now) {
        //           date_nps.sent = date.sent;
        //         }
        //         localStorage.setItem('date_nps', JSON.stringify(date_nps));
        //         localStorage.setItem('nps', JSON.stringify(res.data));
        //       })
        //       .catch((err:any) => {
        //         console.log(err);
        //         localStorage.setItem('nps', JSON.stringify([]));
        //       });
        //   }
        // }
      }
    });

    // Canal de presencia de Desempeño: se sincroniza con la ruta porque al módulo se
    // entra y se sale dentro de la misma sesión (side-menu), no solo al iniciar sesión.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncPerformanceChannel(event.urlAfterRedirects);
      });

    //Add analytics
    if (this.domain != 'localhost') {
      const navEndEvents$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd)
      );

      navEndEvents$.subscribe((event: NavigationEnd) => {
        if (this.userID) {
          gtag('config', environment.GA_TRACKING_ID, {
            user_id: this.userID,
            page_path: event.urlAfterRedirects,
          });
        } else {
          gtag('config', environment.GA_TRACKING_ID);
          gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }

    this.platform.ready().then(async () => {
        // console.log('platform is ready');
      if (this.appPlatformService.isAppPlatform()) {
        if (this.appPlatformService.isIosHibridApp()) {
          this.platformIsIOS = true;
            //! todo
          // // let status bar overlay webview
          // this.statusBar.overlaysWebView(false);
          // // set status bar to white
          // this.statusBar.backgroundColorByHexString('#000000');
        };

        this.checkNewtworkStatus();
        if(!environment.APP_MULTIMARCA){
          await SplashScreen.hide();
        }

        if (this.appPlatformService.isAppPlatform()) {
          this.sqliteWrapper.migrateOldDatabases();
        }

        // Solicita el permiso de notificaciones apenas se abre la app
        // this.pushNotificationsService.requestPermissionsOnAppOpen();
      };

      this.languageService.setDefaultLanguage();
    });

    if (this.appPlatformService.isAppPlatform()){
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          try {
            const excludedRoutes: string[] = ["/validador-evaluacion", "/register", "/encuestas"];
            const slug = event.url;
            console.log("slug:: ",slug);
            const url = new URL(slug);
            const path = url.pathname;
            const query = url.search;

            if (excludedRoutes.includes(path)) {
              let modifiedUrl = url.href;
              if(path === "/validador-evaluacion") {
                modifiedUrl = this.encodeUrl(url);
              };
              this.downloadFileService.downloadMediaWithBrowser(modifiedUrl);
              return;
            }

            // Custom scheme URL (e.g., io.cursalab.app://calendar-pending-activities/calendar?...)
            // hostname is parsed as part of the path in custom schemes
            if (slug.indexOf(environment.CUSTOM_SCHEMA) > -1) {
              Browser.close().catch(() => {});
              const fullPath = '/' + url.hostname + url.pathname;
              if (fullPath && fullPath !== '//' && fullPath !== '/') {
                if(!this.userIsLogged) {
                  localStorage.setItem("pendingDeepLink", fullPath + query);
                }
                this.mp.select_group.emit(null);
                this.router.navigateByUrl(fullPath + query);
              }
              return;
            };

            if (slug && path && path !== "//") {
              if(!this.userIsLogged) {
                console.log("---no logueado!!!");
                localStorage.setItem("pendingDeepLink", path + query);
              }
              this.mp.select_group.emit(null);
              this.router.navigateByUrl(path + query);
            };
          } catch (error) {
            console.log("error deeplink::", error);

          };
        });
      });
    };

  }

  ngOnInit() {
    this.subLanguageConfig();
    this.subKeyboardListener();
    this.checkLoadingScreenIsActive();

    //configuracion de ambiente por marca
    if (environment.APP_MULTIMARCA) {
      const finalAppTheme = JSON.parse(localStorage.getItem('config_ambiente') || 'null');
      const advancedCustomization = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
      //* config de ambiente especifica x workspace */
      // console.log("userIsLogged::", this.userIsLogged)
      // console.log({"finalAppTheme": finalAppTheme, "advancedCustomization": advancedCustomization});
      if (this.userIsLogged && finalAppTheme) {
        this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomization, finalAppTheme, false);
      }


      let apiConnectors = this.api.getApiUrls;
      const apiUrlForBrand = localStorage.getItem('api_urls');
      if (apiConnectors.serviceBase === '' || !apiConnectors.serviceBase) {
        if (apiUrlForBrand) this.api.setApiUrls = JSON.parse(apiUrlForBrand);
      }

      const certificateUrlBase = this.up.getRutaBase;
      if (!certificateUrlBase && apiUrlForBrand) {
        this.up.genera_rutas();
      }
    } else {
      if (this.userIsLogged) {
        this.getBrandedPlanThemeConfig(true);
      }
    };

    this.unregisterServiceWorker();

    this.orientationSubscription = this.orientationService.isLandscape$.subscribe(
      (isLandscape) => {
        this.isLandscape = isLandscape;
        // console.log(
        //     "***isLandscape from app::",
        //     isLandscape,
        //     isLandscape &&
        //     (
        //       this.router?.url?.includes('escuela/') ||
        //       (this.router?.url?.includes('induccion/') && this.router?.url?.includes('tema/'))
        //     )
        //     && !this.router.url?.includes('beneficio/'),
        //     {
        //       escuela: this.router?.url?.includes('escuela/'),
        //       induccion:  this.router?.url?.includes('induccion/'),
        //       tema:  this.router?.url?.includes('tema/'),
        //       beneficio:  !this.router.url?.includes('beneficio/')
        //     }
        // )
      }
    );

    this.notificationsActivitiesService.initNotificationsAndActivities(); // inicia para que al abrir la web/app sea visible el bullet de notificación pendiente si es que hubiera

    this.pushPermissionSubscription = this.pushNotificationsService.showManualEnableModal$.subscribe(() => {
      this.pushPermissionModalIsOpen = true;
    });
  }

  closePushPermissionModal() {
    this.pushPermissionModalIsOpen = false;
  }

  goToNotificationSettings() {
    this.pushNotificationsService.openNotificationSettings();
    this.pushPermissionModalIsOpen = false;
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      try {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => registration.unregister());
        });
      } catch (error) {
        console.log(error);
      };
    };
  }

  checkNewtworkStatus() {
    console.log('*app.ts - initializeNetworkEvents!!!*');
    this.networkService.initializeNetworkEvents();
    this.networkObservable = this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
       this.networkIsActive = status == ConnectionStatus.Online;
       console.log("checkNewtworkStatus desde app.ts", this.networkIsActive)
    });
  }

  async reloadMessage() {
    // todo probar service worker
    const modalAvailable = await this.modalCtrl.create({
      component: MultipleOptionModalComponent,
      backdropDismiss: false,
      cssClass: 'reload-modal',
      componentProps: {
        firstButtonText: 'Actualizar ahora',
        secondButtonText: 'Actualizar más tarde',
        customStyle: 'w-10/12 sm:w-88 md:w-96 custom-reload-modal-width',
      },
    });
    await modalAvailable.present();

    const { data } = await modalAvailable.onWillDismiss();

    if (data.option === 'first') {
      console.log('reload');
      this.swUpdate
        .activateUpdate()
        .then(() => window.location.reload())
        .catch((error:any) => window.location.reload());
    }
  }

  async getBrandedPlanThemeConfig(userIsLogged) {
    const advancedCustomConfigInStorage = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
    let genericTheme;
    try {
      if(userIsLogged) {
        genericTheme = JSON.parse(localStorage.getItem('genericThemeByBrand') || 'null');
      } else {
        genericTheme = await this.api.getConfig();
        localStorage.setItem("genericThemeByBrand", JSON.stringify(genericTheme));
      };
      this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomConfigInStorage, genericTheme, !environment.APP_MULTIMARCA);
    } catch (error) {
      console.log('ERROR - default config: ', error);
      this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomConfigInStorage, this.defaultConfigData, !environment.APP_MULTIMARCA);
    }
  }



  // Une o saca al usuario del canal de presencia performance.web.<slug> según esté dentro del
  // módulo de Desempeño. EchoService ignora ambas llamadas si los sockets no están
  // habilitados para el workspace o si aún no hay conexión.
  private syncPerformanceChannel(url: string) {
    if (!this.userIsLogged) {
      return;
    }

    if (url.split('?')[0].startsWith('/performance')) {
      this.echoService.joinPerformanceChannel(this.data_usuario?.workspace?.slug);
    } else {
      this.echoService.leavePerformanceChannel();
    }
  }

  // collect that title data properties from all child routes
  getTitle(state, parent):any {
    var data = [];

    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }
  async logoutImpersonation() {
    await this.api
      .logout_token()
      .then((res) => {
        this.up.clearStorage();
        this.showImpersonationBar = false;
        this.impersonationBarTitle = '';
        this.router.navigate(['login']);
      })
      .catch((e) => {
        console.log(e.status, e.url);
      });
  }
  addGoogleAnalyticsScript() {
    if (this.domain != 'localhost') {
      let gtagScript: HTMLScriptElement = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src =
        'https://www.googletagmanager.com/gtag/js?id=' +
        environment.GA_TRACKING_ID;
      document.head.prepend(gtagScript);

      /** Disable automatic page view hit to fix duplicate page view count  **/
      gtag('config', environment.GA_TRACKING_ID, { send_page_view: false });
    }
  }

  encodeUrl(parsedUrl) {
    const apiUrl = parsedUrl.searchParams.get('api_url');
    const identificator = parsedUrl.searchParams.get('identificator');
    const course = parsedUrl.searchParams.get('course_id');
    const topic = parsedUrl.searchParams.get('topic_id');
    return parsedUrl.origin + parsedUrl.pathname + `?api_url=${encodeURIComponent(apiUrl)}&identificator=${identificator}&course_id=${course}&topic_id=${topic}`;
  }

  async getMultibrandStoredLoginConfig() {
    // Este método corre en cada emisión de "usuario no logueado", y `clearStorage()`
    // también la dispara al *empezar* un login (login.page.ts limpia el storage
    // antes de autenticar). Si el tema pintado es el de otra marca (pre-login o
    // subdominio recién resueltos, aún sin entrada en `savedThemes`), repintar
    // `lastThemeUsed` devolvería el login a la última marca logueada mientras el
    // usuario sigue en la pantalla de la marca nueva. Ver pages/login/CLAUDE.md.
    if (this.loginMultiModuloService.appliedThemeBelongsToOtherBrand()) return;

    const lastTheme = await this.loginMultiModuloService.getLastThemeUsed();

    // Marca resuelta en pre-login/subdominio y todavía sin entrada en `savedThemes`
    // (nunca logueó en ella): su tema vive en `config_ambiente`. Sin esto, un
    // arranque en frío -recarga o retorno de un SSO en pestaña nueva- la pintaría
    // con el tema genérico de Cursalab.
    const preLoginTheme = !lastTheme && this.loginMultiModuloService.preLoginBrand
      ? JSON.parse(localStorage.getItem('config_ambiente') || 'null')
      : null;

    const baseThemeToApply = lastTheme || preLoginTheme || this.defaultConfigData;

    console.log("theme final de usuario multimarca no logueado:", baseThemeToApply);
    this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(null, baseThemeToApply, false);
  }

  checkLoadingScreenIsActive() {
    this.LoadingSubscription = this.fp.loadingScreenIsActive$.subscribe(isActive => {
      this.loadingScreenIsActive = isActive;
    });
  }

  ngOnDestroy() {
    if (this.checkUpdateInterval) {
      this.checkUpdateInterval.unsubscribe();
    }
    this.networkObservable?.unsubscribe();
    this.keyboardSubscription?.unsubscribe();
    this.orientationSubscription?.unsubscribe();
    this.LoadingSubscription?.unsubscribe();
    this.pushPermissionSubscription?.unsubscribe();
  }

  onMenuIsOpen(isOpen) {
    this.mobileMenuIsOpen = isOpen;
  }

  subKeyboardListener() {
    this.keyboardSubscription = this.keyboardService.keyboardStatus$.subscribe( isHidden => {
        this.keyboardHidden = isHidden;
      }
    );
  }


}
